export type AuditDataAssetsV2Body = {
  categoryId: string;
  paramDefinitionId: string;
  imageId: string | null;
  updatedAt: string | null;
  metaValue: string | null;
  directoryId?: string | null;
  uploadedAssetId: string;
};
